/**
 * @exports
 * @class ApplicationBlock
 */
import * as Flickity from 'flickity';

import { get } from '../../helpers/utilities';

export class ApplicationBlock {
    public static selector = '.js-application-block';
    private root: Element;


    /**
     * Initialises a new instance of ApplicationBlck
     * 
     * @param root The root element for this block
     */
    constructor(root: Element) {
        this.root = root;
    
        this.galleryBtns();
    }


    /**
     * Initialises the gallery buttons.
     * 
     * @private
     * @returns void
     */
    private galleryBtns(): void {
        const galleryElem = get('.js-application-block__gallery', this.root) as Element;
        const observer    = new IntersectionObserver(entries => {
            entries.forEach(entry => {
                if(entry.intersectionRatio > 0.25) {
                    const instance = Flickity.data(galleryElem);
    
                    if(instance) {
                        instance.resize();
        
                        // Next button.
                        const nextBtn = get('.js-application-block__gallery-next-btn', this.root);
                        if(nextBtn) {
                            nextBtn.addEventListener('click', () => {
                                instance.next();
                            });
                        }
        
                        // Previous button.
                        const prevBtn = get('.js-application-block__gallery-previous-btn', this.root);
                        if(prevBtn) {
                            prevBtn.addEventListener('click', () => {
                                instance.previous();
                            });
                        }
                    }

                    observer.unobserve(entry.target);
                }
            });
        }, { threshold: [0, 0.25, 0.5, 0.75, 1] });
        observer.observe(galleryElem);
    }
}
